import { render } from "./TravelPassSelectJourney.vue?vue&type=template&id=66f82830&lang=pug"
import script from "./TravelPassSelectJourney.vue?vue&type=script&lang=ts"
export * from "./TravelPassSelectJourney.vue?vue&type=script&lang=ts"
script.render = render

export default script